import React from "react";
import { Sprak } from "./enums";

interface Props {
  sprak: Sprak;
}

export function Varsel({ sprak }: Props) {
  const feilmelding = hentFeilmelding(sprak);

  return (
    <div className="container">
      <div className="beskjedboks beskjedboks-feil">
        <div className="uthevet-melding er-feil">
          <span className="hovedmelding">{feilmelding}</span>
        </div>
      </div>
    </div>
  );
}

function hentFeilmelding(sprak: Sprak) {
  switch (sprak) {
    case Sprak.NO:
      return "Tjenesten er utilgjengelig på grunn av en teknisk feil. Vi jobber med å løse feilen. Vi beklager ulempene og ber deg prøve igjen senere.";
    case Sprak.EN:
      return "The facility is unavailable due to a technical error. We are working to solve the problem. We regret the inconvenience caused and ask you to please try again later.";
    case Sprak.NN:
      return "Tenesta er utilgjengeleg på grunn av ein teknisk feil. Vi jobbar med å rette feilen. Vi beklagar ulempene og ber deg prøve igjen seinare.";
  }
}
